<div class="message" [class.message-new]="isUnread" [class.message--patient]="senderType() === 'patient'" [class.message--staff]="senderType() !== 'patient'">
  <div class="message-bg">
    @if (isSms) {
      <div class="text-style">Text Message</div>
    }

    <div class="message-header">
      <strong class="color-primary name-style">{{ senderName }}</strong>
      <ng-content select="[bubble-indicator]" />
      <span class="message-meta">
        <span class="message-date">Sent: {{ sentDate | date: 'dd/MMM/yy h:mm a' }}</span>
        <span class="message-date">{{ readDate ? 'Read: ' + (readDate | date: 'dd/MMM/yy h:mm a') : 'Not read' }}</span>
      </span>
    </div>

    <p class="message-content" [innerHTML]="contentHtml()"></p>

    @for (widget of widgets(); track $index) {
      <ng-container *ngComponentOutlet="widget.component; inputs: widget.inputs" />
    }

    @if (showActions() && isIncoming) {
      <div class="message-actions">
        @if (!message().category_name) {
          <select (change)="onCategoryChange($event)">
            <option value="">Assign to</option>
            @for (cat of categories(); track cat.id) {
              <option [value]="cat.id">{{ cat.name }}</option>
            }
          </select>
        } @else {
          <span class="category-tag">{{ message().category_name }}</span>
        }
        <button class="btn btn-sm btn-default" (click)="onReadToggle()">
          {{ message().read ? 'Mark as unread' : 'Mark as read' }}
        </button>
      </div>
    }

    @if (isOutgoing) {
      <small class="read-status">{{ message().read ? 'Read' : 'Unread' }}</small>
    }
  </div>
</div>
